import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import { NewsletterField } from '@modules/newsletter/newsletter-field';

function label(name) {
  return i18n(`entities.comment.fields.${name}`);
}

function enumeratorLabel(name, value) {
  return i18n(`entities.comment.enumerators.${name}.${value}`);
}

const fields = {
  id: new IdField('id', label('id')),
  admin: NewsletterField.relationToOne('admin', label('admin'), {
    "required": true
  }),
  comment: new StringField('comment', label('comment'), {
    "max": 140,
    "required": true
  }),
  status: new EnumeratorField('status', label('status'), [
    { id: 'publish', label: enumeratorLabel('status', 'publish') },
    { id: 'draft', label: enumeratorLabel('status', 'draft') },
  ],{
    "required": true
  }),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),

};

export class CommentModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
